export default __webpack_public_path__ + "static/southlands-card-e6916d1f91c96d163e202b58f4c16087.jpg";